import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  /** @type {number | undefined} */
  _hideMessageTimeoutId;

  /** @type {number | undefined} */
  _swapRestoreTimeoutId;

  copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    const feedbackMs = Number.parseInt(this.dataset.feedbackMs ?? '', 10);
    const ms = Number.isFinite(feedbackMs) && feedbackMs > 0 ? feedbackMs : 2500;
    const swapTargetId = this.dataset.swapTarget?.trim();

    navigator.clipboard.writeText(copyContent).then(() => {
      const copySuccessMessage = this.refs.copySuccessMessage;

      if (copySuccessMessage instanceof Element) {
        if (this._hideMessageTimeoutId) {
          clearTimeout(this._hideMessageTimeoutId);
        }

        copySuccessMessage.classList.remove('visually-hidden');
        this._hideMessageTimeoutId = window.setTimeout(() => {
          copySuccessMessage.classList.add('visually-hidden');
          this._hideMessageTimeoutId = undefined;
        }, ms);
      }

      if (swapTargetId) {
        const swapEl = document.getElementById(swapTargetId);

        if (swapEl instanceof HTMLElement) {
          if (this._swapRestoreTimeoutId) {
            clearTimeout(this._swapRestoreTimeoutId);
          }

          const successLabel = this.dataset.swapLabel?.trim() || 'Copied';
          swapEl.textContent = successLabel;
          this._swapRestoreTimeoutId = window.setTimeout(() => {
            swapEl.textContent = copyContent;
            this._swapRestoreTimeoutId = undefined;
          }, ms);
        }
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this._hideMessageTimeoutId) {
      clearTimeout(this._hideMessageTimeoutId);
    }

    if (this._swapRestoreTimeoutId) {
      clearTimeout(this._swapRestoreTimeoutId);
    }
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
